/**
 * Hàm này dung để kiểm tra xem có phải đối tượng hay không
 * @param {object} value
 */
export const isObject = value => {
	return value && typeof value === 'object';
};

/**
 * Kiểm tra xem giá trị có rỗng hay không
 * @param {string} value
 */
export const isNullOrEmpty = value => !value || value == '' || value == ' ';

/**
 * Hàm này dùng để kiểm tra xem mảng rỗng hay có dữ liệu
 * @param {Array} values
 */
export const isArrayEmpty = values => {
	if (values == null || !Array.isArray(values) || values.length <= 0) {
		return true;
	}

	return false;
};

/**
 * Lấy bản ghi đầu tiên trong mảng
 * @param {Array} values
 * @param {Function} values (item) => {}
 */
export const getFirstOrDefaultFromArray = (values, condition) => {
	try {
		// Kiểm tra mảng rỗng
		if (isArrayEmpty(values)) {
			return null;
		}

		// Nếu có điều kiện thì lấy dữ liệu theo condition
		let res = null;
		if (condition) {
			res = values.find(item => condition(item));
		}

		// Nếu tìm không thấy kết quả thì trả về giá trị tại index 0
		if (!res) {
			res = values[0];
		}

		return res;
	} catch {
		return null;
	}
};

/**
 * Tìm giá trị trong mảng
 * @param {Array} values
 * @param {Function} values (item) => {}
 */
export const findItemFromArray = (values, condition) => {
	if (isArrayEmpty(values) || !condition) return null;

	return values.find(item => condition(item));
};

/**
 * Tìm nhiều giá trị trong mảng
 * @param {Array} values
 * @param {Function} values (item) => {}
 */
export const filterItemFromArray = (values, condition) => {
	if (isArrayEmpty(values) || !condition) return null;

	return values.filter(item => condition(item));
};

/**
 * Lấy giá trị của thuộc tính trong đối tượng theo key
 * @param {object} value
 * @param {string} key
 */
export const getValueFromKeyOfObject = (value, key) => {
	try {
		if (key && isObject(value)) {
			return value[key];
		}

		return null;
	} catch {
		return null;
	}
};

/**
 * Lấy giá trị trong đối tượng đầu tiên của mảng
 * @param {Array} values
 * @param {string} key
 * @param {Function} values (item) => {}
 */
export const getValueFromFirstOrDefaultOfArray = (values, key, condition) => {
	return getValueFromKeyOfObject(
		getFirstOrDefaultFromArray(values, condition),
		key
	);
};
